export default __webpack_public_path__ + "static/logo-2fbfc30a1d263b06ecd37a6a854d8f87.svg";